import { RingLoader } from "react-spinners";
import styles from "./Loader.module.scss";
import cn from "classnames";
import { CSSProperties } from "react";

interface ILoaderProps {
  fill?: boolean;
  touch?: boolean;
  size?: number;
  style?: CSSProperties;
  className?: string;
  absolute?: boolean;
  transparent?: boolean;
}

export default function Loader({
  fill = false,
  touch = false,
  transparent = false,
  size = 100,
  style,
  className,
  absolute,
}: ILoaderProps) {
  return (
    <div
      className={cn(styles.wrapper, className, {
        [styles.fill]: fill,
        [styles.touch]: touch,
        [styles.transparent]: transparent,
      })}
      style={absolute ? {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        transform: "none",
        zIndex: 100,
      } : style}
    >
      <RingLoader size={size} />
    </div>
  );
}
